import { render, staticRenderFns } from "./PanelList.vue?vue&type=template&id=540a53c2&scoped=true&"
import script from "./PanelList.vue?vue&type=script&lang=js&"
export * from "./PanelList.vue?vue&type=script&lang=js&"
import style0 from "./PanelList.vue?vue&type=style&index=0&id=540a53c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a53c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540a53c2')) {
      api.createRecord('540a53c2', component.options)
    } else {
      api.reload('540a53c2', component.options)
    }
    module.hot.accept("./PanelList.vue?vue&type=template&id=540a53c2&scoped=true&", function () {
      api.rerender('540a53c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelList.vue"
export default component.exports